import React, { Component } from 'react'
import styled from 'styled-components'
import Logic from './logic'
import { Grid } from 'react-flexbox-grid'

@Logic
class App extends Component {
  render () {
    return (
      <Wrapper>
        <Anchor id='anchor' />
        {!this.props.loading && this.props.children}
      </Wrapper>
    )
  }
}

export default App

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

export const Container = styled(Grid)`
  max-width: 1200px;
  margin: 0 auto;
`

const Anchor = styled.div``



// WEBPACK FOOTER //
// ./src/containers/App/index.js